/**
 * Edit-form helper: show mass/volume + unit inputs for sell-per-item products
 * only when the existing product already stored those values (pre-UX-change
 * catalog). New item products send empty strings and keep size in the name.
 */
export const hasLegacyItemMassFields = (product: {
  bp_product_mass?: string | number | null;
  bp_product_unit_of_mass?: string | null;
} | null | undefined): boolean => {
  if (!product) return false;
  const massStr = String(product.bp_product_mass ?? '').trim();
  const massNum = Number(massStr);
  const hasMass =
    massStr.length > 0 && Number.isFinite(massNum) && massNum > 0;
  const hasUnit = String(product.bp_product_unit_of_mass ?? '').trim().length > 0;
  return hasMass || hasUnit;
};
